import { ARTICLE_STATUS } from "./articleConstants";

/**
 * Resolves article status from API response fields.
 */
export const resolveArticleStatus = (item) => {
  if (!item) return ARTICLE_STATUS.DRAFT;

  const raw =
    item.status ??
    item.Status ??
    item.articleStatus ??
    item.ArticleStatus ??
    "";

  const normalized = String(raw).trim();

  if (normalized === ARTICLE_STATUS.ACTIVE || normalized === "Published") {
    return ARTICLE_STATUS.ACTIVE;
  }

  if (
    normalized === ARTICLE_STATUS.INACTIVE ||
    normalized === "Unpublished" ||
    normalized === "Inactive"
  ) {
    return ARTICLE_STATUS.INACTIVE;
  }

  if (normalized === ARTICLE_STATUS.DRAFT) {
    return ARTICLE_STATUS.DRAFT;
  }

  return ARTICLE_STATUS.DRAFT;
};

export const renderArticleStatusBadge = (status) => {
  const label = resolveArticleStatus({ status });
  let tone = "secondary";
  if (label === ARTICLE_STATUS.ACTIVE) tone = "success";
  else if (label === ARTICLE_STATUS.DRAFT) tone = "warning";

  return <span className={`badge badge-soft-${tone}`}>{label}</span>;
};
